export default __webpack_public_path__ + "static/media/reddit.5dc608e5.svg";